import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

interface StylesProps {
  isOverTop?: boolean
  isOverBottom?: boolean
}

const useStyles = makeStyles<Theme, StylesProps>(theme => ({
  root: {
    position: 'relative',
    backgroundColor: '#fff',
    borderRadius: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    marginBottom: '1rem',
    padding: '0.5rem',
    gap: '0.5rem',
    cursor: 'pointer'
  },

  info: {
    display: 'grid',
    gridTemplateColumns: 'auto auto minmax(0px, 1fr)',
    alignItems: 'center',
    gap: '0.5rem'
  },

  title: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  drag: {},
  drop: {
    position: 'absolute',
    left: '0',
    border: '3px solid transparent',
    boxSizing: 'border-box',
    width: '100%'
  },

  dropTop: {
    top: 'calc(-0.75rem / 2)',
    bottom: '100%',
    borderBottomColor: ({ isOverTop }) =>
      isOverTop ? theme.palette.primary.main : 'transparent'
  },

  dropTopZone: {
    height: 15
  },

  dropBottom: {
    bottom: 'calc(-0.75rem / 2)',
    top: '100%',
    borderTopColor: ({ isOverBottom }) =>
      isOverBottom ? theme.palette.primary.main : 'transparent'
  },
  childRoot:{
    width: '100%',
  }
}))

export default useStyles
